var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7246 20L16.2386 15.506L20.7246 20ZM18.7246 9.5C18.7246 11.7543 17.8291 13.9163 16.235 15.5104C14.641 17.1045 12.4789 18 10.2246 18C7.97027 18 5.80826 17.1045 4.2142 15.5104C2.62014 13.9163 1.72461 11.7543 1.72461 9.5C1.72461 7.24566 2.62014 5.08365 4.2142 3.48959C5.80826 1.89553 7.97027 1 10.2246 1C12.4789 1 14.641 1.89553 16.235 3.48959C17.8291 5.08365 18.7246 7.24566 18.7246 9.5V9.5Z",
    stroke: "#747474",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cf802170.svg";
export { ForwardRef as ReactComponent };